import React, {useEffect} from 'react';

import {LoadingSpinner} from '@albert-io/atomic';

import {holdStaleAppReload} from 'lib/staleAppReload';

import {SaveStatus} from '../../components/QuestionTypes/QuestionType.types';

import useDraftGuess from './useDraftGuess';

interface Props extends PropsWithChildrenOptional {
  storeName?: string;
  submitted?: boolean;
  store?: any;
}

export default function DraftGuessWrapper({
  children,
  storeName = '',
  submitted = false,
  store
}: Props) {
  const {loadDraftGuess, saveStatus, startTimer, warnUser} = useDraftGuess(
    storeName,
    submitted,
    store
  );

  useEffect(() => {
    loadDraftGuess();
  }, [loadDraftGuess]);

  useEffect(() => {
    startTimer();
  }, [storeName, startTimer]);

  useEffect(() => {
    window.addEventListener('beforeunload', warnUser);
    const releaseStaleAppReloadHold = holdStaleAppReload();

    return () => {
      window.removeEventListener('beforeunload', warnUser);
      releaseStaleAppReloadHold();
    };
  }, [warnUser]);

  return submitted || storeName === '' || saveStatus !== SaveStatus.LOADING ? (
    <>{children}</>
  ) : (
    <LoadingSpinner />
  );
}
